import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { FilesInterceptor } from '@nestjs/platform-express';
import { ApiConsumes, ApiHeader, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { imageFileFilter } from '../shared/file-upload';
import { AllEventsResponseModel, EventResponseModel, SingleEventResponseModel } from './dto/event-response-module';
import { EventDTO, EventPagDto, EventRSVPDto, EventStatusDTO, EventUpdateDTO, GetEventDTO } from './dto/event.dto';
import { EventService } from './event.service';
import { diskStorage } from 'multer';
import { extname } from 'path';
import { ErrorResponse } from '@gtpl/shared-models/common-models';

@ApiTags('Event')
@Controller('event')
export class EventController {

    constructor (
        private EventService:EventService
    ) {}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createEvent')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('attachments', 5, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/eventPics',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async createEvent(@Query() queryParams, @UploadedFiles() attachments,@Body() eventDto:EventDTO, @Req() request: Request): Promise<EventResponseModel> {
        console.log(eventDto,"46")
        try {
            const eventData = await this.EventService.createEventWithData(queryParams, eventDto);
            if(eventData) {
                const postData = await this.EventService.createEventPostWithData(queryParams, eventDto);
                const response = [];
                attachments.forEach(file => {
                    const fileReponse = {
                        eventId:eventData.Id,
                        userId:eventDto.userId,
                        fileType: file.originalname.match(/\.(jpg|jpeg|png|gif)$/) ? 'image' : 'video',
                        fileUrl: `event/eventPics/${file.filename}`
                    };
                    response.push(fileReponse);
                })
                return await this.EventService.createEventAttachments(queryParams, response, eventData.Id);
            } else {
                throw new ErrorResponse(11106, 'Event Not Saved')
            }
        } catch (error) {
            return errorHandler(EventResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getAllEvents/:userId')
    @ApiParam({name:'userId'})
    @ApiQuery({name:'apiVersion'})
    @ApiQuery({name:'skip'})
    async getAllEvents(@Query() eventPagDto:EventPagDto, @Param('userId') userId,@Req() request:Request):Promise<AllEventsResponseModel> {
        try {
            return await this.EventService.getAllEvents(eventPagDto, userId, request);
        } catch (error) {
            return errorHandler(AllEventsResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getEventByEventId/:eventId')
    @ApiQuery({name:'apiVersion'})
    @ApiParam({name:'eventId'})
    async getEventByEventId(@Query() queryParams,@Param('eventId') eventId, @Req() request:Request): Promise<SingleEventResponseModel> {
        try {
            return await this.EventService.getEventByEventId(queryParams, eventId, request);
        } catch (error) {
            return errorHandler(SingleEventResponseModel, error);
        }
    }
    
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateEvent')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('attachments', 5, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/eventPics',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async updateEvent(@Query() queryParams, @UploadedFiles() attachments,@Body() eventUpdateDTO:EventUpdateDTO, @Req() request: Request): Promise<SingleEventResponseModel> {
        try {
            const response = [];
            attachments.forEach(file => {
                const fileReponse = {
                    eventId:eventUpdateDTO.Id,
                    userId:eventUpdateDTO.userId,
                    fileType: file.originalname.match(/\.(jpg|jpeg|png|gif)$/) ? 'image' : 'video',
                    fileUrl: `event/eventPics/${file.filename}`
                };
                response.push(fileReponse);
            })
            return await this.EventService.updateEvent(queryParams, response,eventUpdateDTO, request);
        } catch (error) {
            return errorHandler(SingleEventResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateEventStatus')
    @ApiQuery({name:'apiVersion'})
    async updateEventStatus(@Query() queryParams, @Body() eventStatusDTO:EventStatusDTO, @Req() request: Request): Promise<EventResponseModel> {
        try {
            return await this.EventService.updateEventStatus(queryParams, eventStatusDTO, request);
        } catch (error) {
            return errorHandler(EventResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/eventRSVP')
    @ApiQuery({name:'apiVersion'})
    async eventRSVP(@Query() queryParams, @Body() eventrsvpDTO:EventRSVPDto, @Req() request: Request): Promise<EventResponseModel> {
        try {
            return await this.EventService.eventRSVP(queryParams, eventrsvpDTO, request);
        } catch (error) {
            return errorHandler(EventResponseModel, error);
        }
    }

    @Get('/eventPics/:imgpath')
    @ApiParam({name:'imgpath'})
    seeUploadedFile(@Param('imgpath') Image, @Res() res) {
		try {
			return res.sendFile(Image, { root: './public/eventPics' });
		} catch (error) {
			return error.message;
		}
	}

}
